<template>
  <v-app>
    <v-content>
      <Header />
      <Nav />
      <router-view></router-view>
      <Footer />
    </v-content>

  </v-app>
</template>

<script>
import Header from './components/Header';
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
export default {
  components: {
    Header,
    Nav,
    Footer,
  },
  name: 'App',
  data () {
    return {

    }
  }
};
</script>

<style>
  ::-webkit-scrollbar {
    display: none!important;
  }

  .v-timeline-item__dot--small {
    height: 14px!important;
    left: calc(50% - 12px)!important;
    width: 14px!important;
  }

  .v-timeline-item__body {
    margin-top: -14px!important;
    left: -14px!important;
  }

</style>